export default __webpack_public_path__ + "static/media/man-with-targets-as-destinations-long-road.7dc21935.svg";